import { useRecoilState } from 'recoil';
import { onBoardStateAtom } from './OnBoardStep.atoms';

export const useOnBoardStep = () => {
  const [onBoardState, setOnBoardState] = useRecoilState(onBoardStateAtom);

  const setStep = (step: number) => {
    setOnBoardState(prev => ({ ...prev, step }));
  };

  const isWritten = (array1: [], array2: []) => {
    return (array1 && array1.length > 0) || (array2 && array2.length > 0)
      ? '다음으로'
      : '다음에 작성하기';
  };

  return { setStep, onBoardState, isWritten };
};
